// "Teilen" / "Share" sheet of the chat composer (mobile MessageMenuPro.ProShareSheet):
// title, close and a 4-column grid of 56 radius-16 accent-tinted tiles with the label under
// each (600 12/15). Disabled tiles are dimmed and the reason is shown under the grid.
// Drawn by the 1:1 and group attach dialogs (pages/*/Dialogs/FloatingAction).
import React, { useEffect, useRef } from "react";
import "./ChatShareSheet.css";

// Tile icon per kind; every tile is tinted in the package accent (internal rooms: internal).
const ICONS = {
  media: "perm_media",
  document: "description",
  location: "location_on",
  meeting: "where_to_vote",
  poll: "poll",
};

/**
 * items [{ key, kind, label, disabled, onClick }] · note = text under the grid (e.g. the
 * admin's media lock) · onClose · closeLabel · isInternal (internal rooms keep their tone).
 */
export default function ChatShareSheet({ title, items = [], note, onClose, closeLabel, isInternal }) {
  const panelRef = useRef(null);

  useEffect(() => {
    const first = panelRef.current && panelRef.current.querySelector(".kjc-share__tile:not(.is-disabled)");
    if (first) first.focus({ preventScroll: true });
  }, []);

  return (
    <div
      ref={panelRef}
      className={`kjc-share${isInternal ? " kjc-share--internal" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="kjc-share__handle" aria-hidden="true" />
      <div className="kjc-share__head">
        <div className="kjc-share__title">{title}</div>
        <button type="button" className="kj-btn kj-btn--icon kj-btn--round kjc-share__close" onClick={onClose} aria-label={closeLabel} title={closeLabel}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>
      <div className="kjc-share__grid">
        {items.filter(Boolean).map((it) => {
          const icon = ICONS[it.kind] || ICONS.media;
          const disabled = !!it.disabled;
          const activate = () => {
            if (!disabled && it.onClick) it.onClick();
          };
          return (
            <div
              key={it.key}
              className={`kjc-share__tile${disabled ? " is-disabled" : ""}`}
              role="button"
              tabIndex={disabled ? -1 : 0}
              aria-disabled={disabled || undefined}
              aria-label={disabled && note ? `${it.label}, ${note}` : it.label}
              onClick={activate}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  activate();
                }
              }}
            >
              <div className="kjc-share__icon">
                <span className="material-symbols-outlined kjc-share__glyph">{icon}</span>
              </div>
              <div className="kjc-share__label">{it.label}</div>
            </div>
          );
        })}
      </div>
      {note ? <div className="kjc-share__note">{note}</div> : null}
    </div>
  );
}
